"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSummary = void 0;
var react_1 = __importDefault(require("react"));
var AccountSummary = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none" }, props),
    react_1.default.createElement("g", { fill: "currentColor", clipPath: "url(#a)" },
        react_1.default.createElement("path", { d: "M41 30.975a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6.778 13.308l30.889-8.222c1.11-.333 2.11.333 2.444 1.445l2.556 9.666c.333 1.111-.334 2.111-1.445 2.445l-30.889 8.333c-1.11.333-2.11-.333-2.444-1.445l-2.556-9.666c-.333-1.111.334-2.222 1.445-2.556Z", opacity: ".3" }),
        react_1.default.createElement("path", { d: "M44 21.642c-1-.445-2-.667-3.222-.667C37.11 21.086 34 24.197 34 27.864c-.111 3.889 3.111 7.111 7 7.111 1.111 0 2.111-.222 3-.667v8.667H4v-32h40v10.667Z" })),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "a" },
            react_1.default.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" }))))); };
exports.AccountSummary = AccountSummary;
